/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface EntityType {
  /**
   * @format int32
   * @example 2
   */
  id?: number;
  name?: string;
}

/** Ошибка при обращении к сервису */
export interface ErrorResponse {
  /**
   * Время возникновения ошибки
   * @format date-time
   * @example "2020-09-25T17:44:42.302+03:00"
   */
  timestamp?: string;
  /**
   * Код состояния HTTP
   * @format int32
   * @example 500
   */
  status: number;
  /**
   * Ошибка
   * @example "ValidationError"
   */
  error: string;
  errors?: any[];
}

export interface ExcelFileDto {
  /** @format byte */
  excelFile?: string;
  organizationCode?: string;
  fileName?: string;
}

export interface ExcelErrorDto {
  message?: string[];
}

export interface ExcelInputDto {
  organizationName?: string;
  reportPackageCode?: string;
  reportVersionCode?: string;
  /** @default true */
  clearData?: boolean;
  /** @format byte */
  excelFile?: string;
}

export interface KeycloakUserDto {
  id?: string;
  userLogin?: string;
  admin?: boolean;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  companyInn?: string;
  companyKpp?: string;
  companyShortName?: string;
  taxInspectionCode?: string;
  taxInspectionName?: string;
  permissions?: any[];
}

export interface OrganizationDto {
  /** @example 100001 */
  code?: string;
  head?: boolean;
  parentCode?: string;
  companyCode?: string;
  /** @format int32 */
  organizationTypeCode?: number;
  /** @example "ООО Ромашка" */
  name?: string;
  description?: string;
  /** @format int32 */
  positionTypeCode?: number;
  personCode?: string;
  /**
   * @format date-time
   * @example "2020-09-01T11:44:46+03:00"
   */
  startDate?: string;
  /**
   * @format date-time
   * @example "2020-09-01T11:44:46+03:00"
   */
  endDate?: string;
  defaultOkvedCode?: string;
  mainSounCode?: string;
  businessTypeCode?: string;
}

export interface OrganizationTypeDto {
  /** @format int32 */
  code?: number;
  name?: string;
  /** @format date-time */
  endDate?: string;
}

export interface CompanyDto {
  /** @example "CODE" */
  code?: string;
  companyCounterparty?: boolean;
  counterpartyTypeCode?: string;
  /** @format date-time */
  documentDate?: string;
  /** @example 777 */
  documentSeriesNumber?: string;
  /** @format date-time */
  endDate?: string;
  counterpartyFirstName?: string;
  /** @example "Общество с ограниченной ответственностью Ромашка" */
  fullName?: string;
  /** @example "A1" */
  identificationDocumentsCode?: string;
  /** @example 7707000001 */
  inn?: string;
  /** @example false */
  isPayAgent?: boolean;
  /** @example 36001001 */
  kpp?: string;
  counterpartyLastName?: string;
  /** @example "latin" */
  latinName?: string;
  legalAddress?: string;
  counterpartyMiddleName?: string;
  /** @example "Ромашка" */
  name?: string;
  ogrnip?: string;
  /** @example "GSL" */
  orgLocal?: string;
  registrationNumber?: string;
  resident?: boolean;
  /** @format date-time */
  startDate?: string;
  taxpayerCode?: string;
  thesOksmCode?: string;
  counterpartyTypeName?: string;
  counterpartyTypeOut?: string;
}

export interface CounterPartyTypeDto {
  /** @format int32 */
  id?: number;
  code?: string;
  name?: string;
  description?: string;
}

export interface CompanyReportDto {
  /** @format int32 */
  id?: number;
  name?: string;
  organizationСode?: string;
  children?: ReportingYearDto[];
}

export interface ReportStructureDto {
  /** @example 1151006001 */
  reportVersionCode?: string;
  /** @example 1151006001 */
  disclosureReportVersionCode?: string;
  /** @example "AERO" */
  organizationCode?: string;
  /** @example "КНД 1151006 - Налоговая декларация по налогу на прибыль организаций" */
  displayName?: string;
  /** @example "1151006.Л1.Р1" */
  code?: string;
  /** @example "1151006.Л1" */
  parentCode?: string;
  /** @example "1151006.Л1" */
  hierarchicalParentCode?: string;
  disclosure?: boolean;
  /** @example "line" */
  reportElementCode?: string;
  /** @example "line" */
  structureElement?: string;
  /** @example "GNIVC_ACCY2021P34С0" */
  reportPackageCode?: string;
  reportCode?: string;
  taxTypeCode?: string;
  children?: ReportStructureDto[];
}

export interface DisclosureReportDto {
  /** @example 1151006001 */
  disclosureReportVersionCode?: string;
  /** @example "AERO" */
  disclosureOrganizationCode?: string;
  /** @example "КНД  1125309" */
  reportCodeExt?: string;
  /** @example "D03_DCLTOT_001" */
  reportVersionCode?: string;
  /** @example "D03_DCLTOT_001" */
  organizationCode?: string;
  disclosure?: boolean;
  /** @example "GNIVC_ACCY2021P34С0" */
  reportPackageCode?: string;
  reportCode?: string;
  reportName?: string;
  taxTypeCode?: string;
  taxTypeName?: string;
  taxObjects?: string[];
}

/** Отчетный год */
export interface ReportingYearDto {
  /** @format int32 */
  id?: number;
  name?: string;
  children?: ReportingGroupDto[];
}

/** Группа отчетности */
export interface ReportingGroupDto {
  /** @format int32 */
  id?: number;
  name?: string;
  children?: ReportingPackageDto[];
}

/** Код пакета отчетов */
export interface ReportingPackageDto {
  /** @format int32 */
  id?: number;
  name?: string;
  reportPackageCode?: string;
  reportPackageStatus?: string;
  reportGroupCode?: string;
  periodCode?: string;
  reportPackageName?: string;
  reportPackageCorrection?: string;
  /** @format int32 */
  reportPackageYear?: number;
  /** @format int32 */
  preparationMonth?: number;
  /** @format int32 */
  preparationDay?: number;
  /** @format int32 */
  disclosureMonthCode?: number;
  /** @format int32 */
  dueDay?: number;
  /** @format date-time */
  reportPublishDate?: string;
  reportPackageUser?: string;
  reportPackageDeclarationRegNumber?: string;
  organization?: string;
  isNextYear?: boolean;
  children?: ReportingTypeDto[];
}

/** Тип отчётов */
export interface ReportingTypeDto {
  /** @format int32 */
  id?: number;
  name?: string;
  /** @format int32 */
  reportTypeOrder?: number;
  children?: ReportingBlockDto[];
}

/** Отчет */
export interface ReportingBlockDto {
  /** @format int32 */
  id?: number;
  name?: string;
  reportCodeExt?: string;
  reportPackageCode?: string;
  reportPublishStatus?: string;
  periodCode?: string;
  reportName?: string;
  reportPackageCorrection?: string;
  /** @format int32 */
  reportPackageYear?: number;
  /** @format int32 */
  preparationMonth?: number;
  /** @format int32 */
  preparationDay?: number;
  /** @format int32 */
  disclosureMonthCode?: number;
  /** @format int32 */
  dueDay?: number;
  /** @format date-time */
  reportPublishDate?: string;
  infoSystemCode?: string;
  reportPublishUser?: string;
  /** @format date */
  buildDate?: string;
  /** @format date */
  uploadDate?: string;
  organizationCode?: string;
  reportVersionCode?: string;
  reportVersionName?: string;
  reportCode?: string;
  taxTypeCode?: string;
  taxTypeName?: string;
  reportTypeCode?: string;
  reportVersionVersion?: string;
  /** @format int32 */
  orderNum?: number;
  hasStructure?: boolean;
  /** @format int32 */
  reportTypeOrder?: number;
  sliceStatus?: string;
  /** @format date */
  sliceDate?: string;
  isNextYear?: boolean;
  hasAttachedFiles?: boolean;
  isDeltaApproach?: boolean;
}

/** Информация о пакете/отчете */
export interface ReportPackageInfoDto {
  reportPackageCodeExt?: string;
  reportPackageDescription?: string;
  /** @format int32 */
  reportPublishItemNumber?: number;
  reportPublishSize?: string;
  reportTypeCode?: string;
  reportDescription?: string;
  reportVersionCode?: string;
  reportVersionVersion?: string;
  reportVersionName?: string;
  externalVersionCode?: string;
  /** @format date-time */
  reportVersionBeginDate?: string;
  /** @format date-time */
  reportVersionFinishDate?: string;
  frequencyCode?: string;
  frequencyName?: string;
  reportSettingsSignTCC?: string;
  signInfoSystem?: string;
  formTCC?: string;
  autoForm?: string;
  arbitaryReport?: string;
  autoDecodeDetail?: string;
  autoCheckVersion?: string;
  dataFiltering?: string;
  dataSorting?: string;
  dataGrouping?: string;
  totalCalc?: string;
  dataExport?: string;
  dataPrint?: string;
  fulltextSearchRus?: string;
  reportSettingsTableSource?: string;
  reportSettingsFileStructure?: string;
  reportSettingsTableReceiver?: string;
  infoSystemCode?: string;
  reportSettingsNewWindow?: boolean;
  reportSettingsUrl?: string;
  urlP1?: string;
  urlP2?: string;
  urlP3?: string;
  urlP4?: string;
  urlP5?: string;
  urlP6?: string;
  urlP7?: string;
  urlP8?: string;
  urlP9?: string;
  urlP10?: string;
  reportSettingsCodeExt?: string;
  sourceTypeCode?: string;
  reportPackageStatus?: string;
  /** @format int32 */
  reportPackageYear?: number;
  /** @format int32 */
  disclosureMonthCode?: number;
  /** @format int32 */
  dueDay?: number;
  /** @format date-time */
  buildDate?: string;
  reportPublishStatus?: string;
  periodCode?: string;
  reportPackageCorrection?: string;
  reportPackageUserName?: string;
  reportPackageCode?: string;
  isNextYear?: boolean;
  calendar?: ReportPackageInfoCalendarDto[];
  organizationName?: string;
}

/** Календарь */
export interface ReportPackageInfoCalendarDto {
  /** @format int32 */
  preparationDay?: number;
  /** @format int32 */
  preparationMonthCode?: number;
  /** @format int32 */
  dueDay?: number;
  /** @format int32 */
  disclosureMonthCode?: number;
  periodName?: string;
}

export interface ReportGroupsDto {
  /** @example 100001 */
  code?: string;
  /** @example 100001 */
  codeParent?: string;
  /** @example 100001 */
  codeExt?: string;
  /** @example "ООО Ромашка" */
  name?: string;
  description?: string;
  taxTypeCode?: string;
  regulated?: boolean;
}

/** Код пакета отчетов */
export interface ReportPackageAddonDto {
  organizationCode?: string;
  code?: string;
  reportGroupCode?: string;
  /** @format int32 */
  year?: number;
  periodCode?: string;
  correction?: string;
  codeExt?: string;
  name?: string;
  description?: string;
  /** @format date-time */
  disclosureData?: string;
  /** @format date-time */
  creationData?: string;
  status?: string;
  username?: string;
  declarationRegNumber?: string;
}

export interface XmlDto {
  /** @example "COMPANY_ACCY2021P34С0" */
  packageCode?: string;
  /** @example 1151006 */
  versionCode?: string;
  errors?: string[];
}

export interface ReportPeriodDto {
  reportGroupCode?: string;
  periodCode?: string;
  /** @format int32 */
  preparationMonthCode?: number;
  /** @format int32 */
  preparationDay?: number;
  /** @format int32 */
  dueDay?: number;
  /** @format int32 */
  disclosureMonthCode?: number;
  frequencyCode?: string;
}

export interface ReportSettingDto {
  organizationCode?: string;
  reportVersionCode?: string;
  tableSource?: string;
  tableSourceClient?: string;
  fileStructure?: string;
  tableReceiver?: string;
  newWindow?: boolean;
  /** @example "CODE" */
  url?: string;
  urlP1?: string;
  urlP2?: string;
  urlP3?: string;
  urlP4?: string;
  urlP5?: string;
  urlP6?: string;
  urlP7?: string;
  urlP8?: string;
  urlP9?: string;
  urlP10?: string;
  infoSystemCode?: string;
  signTcc?: string;
  signInfoSystem?: string;
  formTcc?: string;
  autoForm?: string;
  codeExt?: string;
  sourceTypeCode?: string;
  arbitraryReport?: string;
  autoDecodeDetail?: string;
  autoCheckVersion?: string;
  dataFiltering?: string;
  dataSorting?: string;
  dataGrouping?: string;
  totalCalc?: string;
  dataExport?: string;
  dataPrint?: string;
  fulltextSearchRus?: string;
  reportGroupCode?: string;
  reportGroupName?: string;
  reportCodeExtVersion?: string;
  reportVersionName?: string;
  reportTypeCode?: string;
  reportTypeName?: string;
  /** @format int32 */
  reportTypeOrderNum?: number;
  /** @maxLength 255 */
  uiTableSource?: string;
  rounded?: boolean;
  isReportStructureVisible?: boolean;
  isReportPublishVisible?: boolean;
  isDeltaApproach?: boolean;
  script?: string;
}

export interface ReportSettingLevelDto {
  /** @format int32 */
  id?: number;
  level?: string;
  reportTypeLevel?: string;
  groupLevel?: string;
  urlP1?: string;
  urlP2?: string;
  urlP3?: string;
  urlP4?: string;
  urlP5?: string;
  urlP6?: string;
  urlP7?: string;
  urlP8?: string;
  urlP9?: string;
  urlP10?: string;
}

export interface ReportSettingsDeleteDto {
  organizationCode?: string;
  reportVersionCode?: string;
}

/** Реестр публикаций */
export interface ReportPublishDto {
  reportPackageCode?: string;
  reportVersionCode?: string;
  /** @format int32 */
  itemNumber?: number;
  size?: number;
  status?: string;
  /** @format date-time */
  buildDate?: string;
  username?: string;
}

export interface UncreatedReportDto {
  reportPackageCode?: string;
  reportVersionCode?: string;
  reportVersionName?: string;
}

export interface EtlProcessDto {
  guid?: string;
  organization?: string;
  /** @format int32 */
  etlTypeId?: number;
  etlTypeName?: string;
  username?: string;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  result?: string;
  hasErrors?: boolean;
}

export interface EtlLogDto {
  /** @format int64 */
  id?: number;
  /** @format uuid */
  etlGuid?: string;
  operationDescription?: string;
  errorDescription?: string;
  /** @format date-time */
  startDate?: string;
  visible?: boolean;
  reportPackageCode?: string;
  /** @format int32 */
  processedRowCount?: number;
}

export interface EtlTypeDto {
  /** @format int32 */
  id?: number;
  processName?: string;
  etlGroup?: string;
  etlTypeFilter?: string;
}

/** Запрос расчета данных */
export interface CalculationRequestDto {
  reportPackageCode?: string;
  reportVersionCodes?: string[];
}

export interface FrequencyDto {
  code?: string;
  name?: string;
}

export interface MonthDto {
  /** @format int32 */
  code?: number;
  codeExt?: string;
  name?: string;
  /** @format int32 */
  daysNumber?: number;
  lipYear?: string;
}

export interface ReportDto {
  code?: string;
  codeExt?: string;
  reportGroupCode?: string;
  reportGroupName?: string;
  reportTypeCode?: string;
  reportTypeName?: string;
  name?: string;
  description?: string;
  regulated?: boolean;
  /** @format int32 */
  reportTypeOrderNum?: number;
}

export interface ReportTypeDto {
  /** @example 100001 */
  code?: string;
  /** @example 100001 */
  codeExt?: string;
  /** @example "ООО Ромашка" */
  name?: string;
  description?: string;
  /** @format int32 */
  orderNum?: number;
  /** @example "model" */
  dbSchema?: string;
}

export interface CredentialsDto {
  username?: string;
  password?: string;
}

export interface KeyCloakEventDto {
  /** @format int64 */
  time?: number;
  type?: string;
  realmId?: string;
  clientId?: string;
  userId?: string;
  ipAddress?: string;
  details?: object;
}

export interface ReportVersionDto {
  code?: string;
  reportCode?: string;
  reportTypeCode?: string;
  version?: string;
  name?: string;
  externalVersionCode?: string;
  /** @format date */
  beginDate?: string;
  /** @format date */
  finishDate?: string;
  regulated?: boolean;
  reportGroupCode?: string;
  reportGroupName?: string;
  reportCodeExt?: string;
  reportTypeName?: string;
  /** @format int32 */
  reportTypeOrderNum?: number;
}

export interface InfoSystemDto {
  code?: string;
  name?: string;
}

export interface SourceTypeDto {
  code?: string;
  name?: string;
}

export interface AccountInfoDto {
  id?: string;
  userLogin?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  email?: string;
  roles?: string[];
}

export interface DocumentTransactionDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  documentStorageId?: number;
  transactionAccNumber?: string;
  /** @format int32 */
  transactionAccYear?: number;
  reportPackageCode?: string;
  /** @format date-time */
  transactionAccDate?: string;
  /** @format int32 */
  transactionYear?: number;
  /** @format int32 */
  reportPackageYear?: number;
}

export interface DocumentCardDto {
  /** @format int32 */
  id?: number;
  uriBody?: string;
  uniqueDocumentNumber?: string;
  documentFnsNaim?: string;
  documentFnsKod?: string;
  documentNumber?: string;
  /** @format date */
  documentDate?: string;
  /** @format date-time */
  startDate?: string;
  companyCode?: string;
  companyShortName?: string;
  fileName?: string;
  fileContentType?: string;
  /** @format byte */
  file?: string;
  transactionAccNumber?: string;
  /** @format int32 */
  transactionAccYear?: number;
  reportPackageCode?: string;
  organizationCode?: string;
  transactions?: DocumentTransactionDto[];
  importSign?: boolean;
  documentSumGross?: string;
  documentTaxSum?: string;
  userCreated?: string;
  /** @format date-time */
  changeDate?: string;
  userChanged?: string;
  /** @format date-time */
  endDate?: string;
  userDeleted?: string;
  /** @format date-time */
  beginDate?: string;
  /** @format date-time */
  finishDate?: string;
  /** @format date-time */
  hideDate?: string;
  userHiding?: string;
  hiddenDocument?: boolean;
  /** @format date-time */
  displayDate?: string;
  userDisplaying?: string;
}

export interface DocumentCardsFilterDto {
  organizationCode?: string;
  documentFnsKod?: string;
  /** @format date */
  startDocumentDate?: string;
  /** @format date */
  endDocumentDate?: string;
  companyCode?: string;
}

export interface PeriodDto {
  code?: string;
  codeExt?: string;
  name?: string;
}

export interface TableComponentRequestDto {
  resource: string;
  fields?: string[];
  orderBy?: OrderByDto[];
  filter?: FilterDto[];
  hardFilter?: FilterDto[][];
  groupBy?: GroupByDto[];
  openGroup?: OpenGroupDto[];
  aggregate?: Record<string, AggregateEnum>;
  /** @format int32 */
  offset?: number;
  /** @format int32 */
  limit?: number;
  selectRows?: SelectRows;
  operation?: TcOperationDto;
}

export interface FilterDto {
  name: string;
  type: FilterEnum;
  filterIsInverted?: boolean;
  values?: string[];
}

export enum FilterEnum {
  EQ = 'EQ',
  NEQ = 'NEQ',
  LS = 'LS',
  GR = 'GR',
  GEQ = 'GEQ',
  LEQ = 'LEQ',
  SET = 'SET',
  MASK = 'MASK',
  RNG = 'RNG',
  NRNG = 'NRNG',
  UNKNOW = 'UNKNOW',
}

export interface GroupByDto {
  groupField: string;
  aggregate?: Record<string, AggregateEnum>;
}

export interface OrderByDto {
  name: string;
  type?: 'ASC' | 'DESC';
  isNullsFirst?: boolean;
}

export interface SelectRows {
  selectedGroups?: string[][];
  deSelectedGroups?: string[][];
  selectedRowKeys?: string[][];
  deSelectedRowKeys?: string[][];
  modeSelectAll?: boolean;
  operationMode?: OperationEnum;
  keyColumn?: string;
}

/** @example [{"value":"qwe","children":[{"value":"rty"},{"value":"asd","children":[{"value":"zxc"}]}]}] */
export interface OpenGroupDto {
  value?: string;
  children?: OpenGroupDto[];
}

export enum AggregateEnum {
  SUM = 'SUM',
  STR_AGG = 'STR_AGG',
  MIN = 'MIN',
  MAX = 'MAX',
}

export enum OperationEnum {
  DELETE = 'DELETE',
  HIDE = 'HIDE',
  SHOW = 'SHOW',
  COPY = 'COPY',
}

export interface TcOperationDto {
  parameters?: Record<string, string>;
  operationMode?: OperationEnum;
}

export interface ControlDto {
  /** Код контроля */
  ctrlCode?: string;
  /** Внешний код контроля */
  ctrlExt?: string;
  /** Наименование контроля */
  ctrlName?: string;
  /** Код группы отчетности */
  repGroupCode?: string;
  /** Код группы контроля */
  ctrlGroupCode?: string;
}

export interface ControlStepDto {
  /** Код версии контроля */
  ctrlVersCode?: string;
  /**
   * Номер шага
   * @format int32
   */
  stepNum?: number;
  /** Внешний код шага */
  stepCodeExt?: string;
  /** Тип шага */
  stepType?: string;
  /** Наименование шага контроля */
  stepName?: string;
  /** Описание шага контроля */
  stepDesc?: string;
  /** Описание статуса (успех) */
  textSuccess?: string;
  /** Код КС в кодировке ФНС */
  codeFns?: string;
  /** Описание статуса (расхождение >) */
  textFailGt?: string;
  /** Описание статуса (расхождение =) */
  textFailEq?: string;
  /** Описание статуса (расхождение <) */
  textFailLt?: string;
}

export interface ControlStepLogicDto {
  /** Код версии контроля */
  ctrlVersCode?: string;
  /**
   * Номер шага
   * @format int32
   */
  stepNum?: number;
  /** Проверка применимости */
  premise?: string;
  /** Логика контроля */
  formula?: string;
  /**
   * Тип контроля (L - логическое, S - числовое)
   * @maxLength 1
   */
  ctrlType?: string;
  /**
   * Допустимая дельта
   * @format decimal
   * @example "99999.99999"
   */
  delta?: string;
  /** Аналитики */
  ctrlAnalytics?: string;
  /** Настройка аналитик */
  ctrlAnalyticsDet?: string;
  /** Тип округления */
  roundingType?: string;
  /** Десятичный разряд округления */
  decimalQty?: number;
}

export interface ControlVersionDto {
  /** Код версии контроля */
  ctrlVersCode?: string;
  /** Код контроля */
  ctrlCode?: string;
  /**
   * Номер версии
   * @format int32
   */
  versionNum?: number;
  /**
   * Дата начала действия версии
   * @format date-time
   */
  dateFrom?: string;
  /**
   * Дата окончания действия версии
   * @format date-time
   */
  dateTo?: string;
  /** Внешний код версии контроля */
  ctrlVersExt?: string;
  /** Описание версии контроля */
  ctrlVersDesc?: string;
  /** Общее описание статуса (успех) */
  textSuccess?: string;
  /** Общее описание статуса (расхождение) */
  textFail?: string;
  /** Список шагов контроля */
  steps?: ControlStepDto[];
  stepSettings?: ControlStepLogicDto[];
  /** Признак редактируемости версии контроля */
  isEditable?: boolean;
  /** Код группы контролей */
  ctrlGroupCode?: string;
  /** Наименование группы контролей */
  ctrlGroupName?: string;
  /** Порядок групп контролей */
  ctrlGroupOrder?: number;
  /** Код группы отчетности */
  repGroupCode?: string;
}

export interface IndicatorDto {
  /** Версия отчета */
  repVers?: string;
  /** Код показателя */
  varCode?: string;
  /** Поле-источник */
  sourceField?: string;
  /** Группировка (номер колонки grouping_order из register_meta) */
  groupBy?: string;
  /** Описание показателя/переменной */
  varText?: string;
  /** Источник данных */
  varSource?: string;
  /** Функция агрегации */
  aggFunction?: string;
  /** Имя таблицы БД */
  techSourceTable?: string;
  /** Ограничения при выборке показателей (фильтры) */
  filters?: VarFilterDto[];
  /** Тип округления */
  roundingType?: string;
  /** Десятичный разряд округления */
  decimalQty?: number;
  /** Группа отчетности */
  reportGroupCode?: string;
}

export interface StepTypeDto {
  /** Тип шага */
  stepType?: string;
  /** Наименование типа шага */
  stepTypeText?: string;
  /** Описание типа шага */
  stepTypeDesc?: string;
}

export interface FilterOperatorDto {
  code?: string;
  name?: string;
  literal?: string;
}

export interface TableFieldInfoDto {
  tableName?: string;
  columnName?: string;
  columnComment?: string;
  groupNumber?: string;
  groupOrder?: string;
  orderNo?: number;
}

export interface ControlApplicabilityDto {
  orgCode?: string;
  ctrlVersCode?: string;
  stepNums?: number[];
  repGroupCode?: string;
  ctrlCode?: string;
  ctrlGroupCode?: string;
  ctrlGroupName?: string;
  ctrlGroupOrder?: number;
}

export interface CompanyControlReportDto {
  /** @format int32 */
  id?: number;
  name?: string;
  organizationСode?: string;
  children?: ReportingControlYearDto[];
}

/** Отчетный год */
export interface ReportingControlYearDto {
  /** @format int32 */
  id?: number;
  name?: string;
  children?: ReportingControlGroupDto[];
}

/** Группа отчетности */
export interface ReportingControlGroupDto {
  /** @format int32 */
  id?: number;
  name?: string;
  children?: ReportingControlPackageDto[];
}

/** Информация о пакете отчетности */
export interface ReportingControlPackageDto {
  /** @format int32 */
  id?: number;
  /**
   * Наименование пакета отчетности
   * @example "Мой пакет"
   */
  name?: string;
  /**
   * Код группы отчетности
   * @example "LOT"
   */
  reportGroupCode?: string;
  /**
   * Код периода пакета
   * @example "10"
   */
  periodCode?: string;
  /**
   * Код месяца подготовки пакета
   * @format int32
   * @example 11
   */
  preparationMonthCode?: number;
  /**
   * День подготовки пакета
   * @format int32
   * @example 20
   */
  preparationDay?: number;
  /**
   * Код месяца раскрытия пакета
   * @format int32
   * @example 12
   */
  disclosureMonthCode?: number;
  /**
   * День предоставления пакета
   * @format int32
   * @example 20
   */
  dueDay?: number;
  /**
   * Признак следующего года
   * @example true
   */
  nextYear?: boolean;
  /**
   * Код пакета отчетности
   * @example "SOME_CODE2024P10V0"
   */
  reportPackageCodeCm?: string;
  /**
   * Год пакета отчетности
   * @format int32
   * @example 2024
   */
  reportPackageYear?: number;
  /**
   * Признак корректировки пакета отчетности
   * @example "0"
   */
  reportPackageCorrection?: string;
  /**
   * Наименование пакета отчетности
   * @example "Мой пакет"
   */
  reportPackageName?: string;
  /**
   * Пользователь, выполнивший КП по пакету
   * @example "petrov"
   */
  cpckgUserKp?: string;
  /**
   * Статус КП по пакету
   * @example "S"
   */
  cpckgStatus?: string;
  /**
   * Текстовое описание статуса КП по пакету
   * @example "Контроль пройден"
   */
  cpckgStatusText?: string;
  /**
   * Тип статуса КП по пакету
   * @example "w"
   */
  cpckgStatusType?: string;
  /**
   * Дата КП по пакету
   * @format date-time
   * @example "2024-01-01T00:00:00Z"
   */
  cpckgDateKp?: string;
  /**
   * Период КП
   * @example "2024-01-01 - 2024-01-31"
   */
  periodKp?: string;
  /** @example "Organization" */
  organization?: string;
  /**
   * @format int64
   * @example "1234567890"
   */
  execCtrlQty?: number;
  children?: ControlGroupDto[];
  /** @format int32 */
  execCtrlAmount?: number;
  /** @format int32 */
  ctrlAmount?: number;
  /** @format int32 */
  ctrlConfiguredAmount?: number;
}

/** Информация о группе контролей */
export interface ControlGroupDto {
  /** @format int32 */
  id?: number;
  /**
   * Наименование группы контролей
   * @example "Группа контролей выручки и призового фонда"
   */
  name?: string;
  /**
   * Код группы контролей
   * @example "REV_PF"
   */
  ctrlGroupCode?: string;
  /**
   * Наименование группы контролей
   * @example "Группа контролей выручки и призового фонда"
   */
  ctrlGroupName?: string;
  /**
   * Порядок отображения групп контроля
   * @format int32
   * @example 2
   */
  ctrlGroupOrder?: number;
  controlVersions?: ControlGroupVersionDto[];
}

/** Информация о версии контроля */
export interface ControlGroupVersionDto {
  /** @format int32 */
  id?: number;
  /**
   * Код контроля
   * @example "AKP001"
   */
  ctrlCode?: string;
  /**
   * Расширение кода контроля
   * @example "НСК_АКП_001"
   */
  ctrlExt?: string;
  /**
   * Код версии контроля
   * @example "AKP001_001"
   */
  ctrlVersCode?: string;
  /**
   * Расширение кода версии контроля
   * @example "НСК_АКП_001"
   */
  ctrlVersExt?: string;
  /**
   * Номер версии
   * @format int32
   * @example 1
   */
  versionNum?: number;
  /**
   * Описание версии контроля
   * @example "Контроль данных выручки в бухучете по бестиражным лотереям"
   */
  ctrlVersDesc?: string;
  /**
   * Период КП
   * @example "2024-01-01 - 2024-01-31"
   */
  periodKp?: string;
  /**
   * Статус контроля
   * @example "F"
   */
  ctrlStatus?: string;
  /**
   * Текстовое описание статуса контроля
   * @example "Контроль не пройден"
   */
  ctrlStatusText?: string;
  /**
   * Тип статуса контроля
   * @example "w"
   */
  ctrlStatusType?: string;
  /**
   * Дата КП
   * @format date-time
   * @example "2024-02-23T00:00:00"
   */
  ctrlDateKp?: string;
  /**
   * Пользователь, выполнивший КП
   * @example "petrov"
   */
  ctrlUserKp?: string;
  /**
   * Номер запуска проверки КП
   * @example "345678"
   */
  execNum?: number;
}

export interface RunControlRequestDto {
  /** Код пакета */
  reportPackageCode?: string;
  /** Коды версий контроля */
  ctrlVersionCodes?: string[];
}

export interface VarSourceDto {
  /** Код источника данных для показателя */
  varSource?: string;
  /** Описание источника */
  sourceDesc?: string;
}

export interface AggFuncDto {
  /** Функция агрегации */
  aggFunction?: string;
  /** Описание функции */
  aggFuncDesc?: string;
}

export interface VarFilterDto {
  /** Код показателя */
  varCode?: string;
  /**
   * Номер правила
   * @format int32
   */
  orGroup?: number;
  /**
   * Последовательность условий в правиле
   * @format int32
   */
  andGroup?: number;
  /** Имя поля, по которому будет накладываться фильтр */
  fieldName?: string;
  /** Фильтр - Опция(по сути оператор) */
  selOption?: string;
  /** Значение, которому должно удовлетворять условие фильтрации */
  fieldValue?: string;
}

export interface UncreatedControlVersionDto {
  reportPackageCode?: string;
  controlVersions?: string[];
}

export interface ControlVersionWithNameDto {
  controlVersionCode?: string;
  controlName?: string;
  controlVersExt?: string;
}

export interface Property {
  key?: string;
  value?: string;
  defaultValue?: string;
  name?: string;
  type?: string;
  title?: string;
  description?: string;
  relation?: string;
  mustBeFilled?: boolean;
  /** @format int32 */
  sortingPriority?: number;
  /** @format int32 */
  groupMembership?: number;
  uiProperty?: boolean;
}

export interface UserFilterDto {
  id?: string;
  firstName?: string;
  lastName?: string;
  login?: string;
  groupFilter?: string;
  organizationFilter?: string;
}

export interface ReportUserAuditDto {
  /** Description of the keys. */
  description?: Record<string, string>;
  users?: ReportUserFieldDto[];
}

export interface ReportUserFieldDto {
  /** Basic user Information. */
  fields?: Record<string, any>;
}

export interface AppModuleDto {
  /** @format int32 */
  id?: number;
  name?: string;
  shortName?: string;
  services?: AppServiceDto[];
  description?: string;
  /** @format date-time */
  createdAt?: string;
}

export interface AppServiceDto {
  /** @format int32 */
  id?: number;
  name?: string;
  shortName?: string;
  operations?: AppOperationDto[];
  description?: string;
  /** @format date-time */
  createdAt?: string;
}

export interface AppOperationDto {
  /** @format int32 */
  id?: number;
  name?: string;
  description?: string;
  /** @format date-time */
  createdAt?: string;
}

export interface AppAuditDto {
  id?: string;
  parentId?: string;
  sysUser?: string;
  appUser?: string;
  ipAddress?: string;
  host?: string;
  moduleName?: string;
  serviceName?: string;
  operationName?: string;
  /** @format int32 */
  operationId?: number;
  message?: string;
  result?: string;
  businessInfo?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
}

/** Основная сущность, описывающая шаблон секций документа и его глобальные настройки */
export interface DocumentSectionTemplateDto {
  /**
   * Уникальный идентификатор ресурса
   * @example "v_ctrl_ctrl"
   */
  resource: string;
  /**
   * Идентификатор ресурса для поиска значений полей заголовка
   * @example "v_ctrl_main"
   */
  resourceHeader?: string;
  /**
   * Признак наличия хедера у секции
   * @example true
   */
  hasHeader?: boolean;
  /**
   * Признак наличия футера у секции
   * @example true
   */
  hasFooter?: boolean;
  /**
   * Признак наличия поля 'Наименование отчета'
   * @example true
   */
  hasReportName?: boolean;
  /**
   * Альтернативное наименование отчета
   * @example "Квартальный финансовый отчет"
   */
  alternativeReportName?: string;
  /**
   * Время создания записи
   * @format date-time
   * @example "2025-11-12T10:00:00"
   */
  createdAt?: string;
  /**
   * Время последнего обновления записи
   * @format date-time
   * @example "2025-11-12T10:00:00"
   */
  updatedAt?: string;
}

/** Настройки для футера документа */
export interface FooterSettingDto {
  /**
   * Идентификатор ресурса
   * @example "v_ctrl_ctrl"
   */
  resource: string;
  /**
   * Признак вывода даты и времени формирования
   * @example true
   */
  footerDatetime?: boolean;
  /**
   * Признак вывода имени пользователя, сформировавшего отчет
   * @example true
   */
  footerUsername?: boolean;
  /**
   * Признак вывода фильтров, используемых в запросе
   * @example false
   */
  footerParams?: boolean;
}

/** Полный шаблон документа */
export interface FullTemplateDto {
  template?: any;
  /** Список настроек для хедера */
  headerSettings?: any[];
  footerSetting?: any;
  /** Список хард-фильтров, необходимых для получения данных заголовка */
  headerFilters?: any[];
}

/** Настройки строки хедера */
export interface HeaderRowSettingDto {
  /**
   * Идентификатор ресурса
   * @example "v_ctrl_ctrl"
   */
  resource?: string;
  /**
   * Порядковый номер строки в заголовке для сортировки
   * @example 1
   */
  cellOrder?: number;
  /**
   * Наименование поля
   * @example "Организация"
   */
  fieldName?: string;
  /**
   * Источник данных для поля
   * @example "[hard_filter]organization"
   */
  fieldSource?: string;
  /**
   * Количество пустых строк (отступ) перед предыдущей строкой
   * @example 1
   */
  intervalsUp?: number;
  /**
   * Признак вывода полного имени организации
   * @example false
   */
  organizationFullName?: boolean;
  /**
   * Признак разворачивания строки в блок 'Организация', 'ИНН', 'КПП'
   * @example true
   */
  organizationInnKpp?: boolean;
  /**
   * Признак разворачивания строки в блок из 7 полей путем парсинга кода пакета
   * @example false
   */
  packageParsing?: boolean;
  /**
   * Источник дополнительного описания поля заголовка
   * @example "cm.report_group.group_desc[code]"
   */
  descriptionSource?: string;
}

/** Описывает связь между шаблоном и хард-фильтром, необходимым для получения данных заголовка */
export interface ResourceHeaderFilterDto {
  /**
   * Идентификатор ресурса
   * @example "v_ctrl_ctrl"
   */
  resource?: string;
  /**
   * Идентификатор ресурса-источника данных для заголовка
   * @example "v_ctrl_main"
   */
  resourceHeader?: string;
  /**
   * Наименование хард-фильтра, значение которого нужно для запроса
   * @example "organization"
   */
  hardFilter?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = '';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title CM API
 * @version 0.0.1-SNAPSHOT
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  currentUser = {
    /**
     * No description
     *
     * @name GetCurrentUser
     * @summary Получить пользователя
     * @request GET:/currentUser
     * @secure
     */
    getCurrentUser: (params: RequestParams = {}) =>
      this.request<KeycloakUserDto, ErrorResponse>({
        path: `/currentUser`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  organizations = {
    /**
     * No description
     *
     * @name GetOrganizations
     * @summary Получить оргструктуру организации
     * @request GET:/organizations
     * @secure
     */
    getOrganizations: (params: RequestParams = {}) =>
      this.request<OrganizationDto[], ErrorResponse>({
        path: `/organizations`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Создать организацию
     *
     * @name AddOrganization
     * @request POST:/organizations
     * @secure
     */
    addOrganization: (data: OrganizationDto, params: RequestParams = {}) =>
      this.request<OrganizationDto, ErrorResponse>({
        path: `/organizations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Обновить организацию
     *
     * @name UpdateOrganization
     * @request PUT:/organizations
     * @secure
     */
    updateOrganization: (data: OrganizationDto, params: RequestParams = {}) =>
      this.request<OrganizationDto, ErrorResponse>({
        path: `/organizations`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetOrganization
     * @summary Получить карточку организации по коду
     * @request GET:/organizations/{code}
     * @secure
     */
    getOrganization: (code: string, params: RequestParams = {}) =>
      this.request<OrganizationDto, ErrorResponse>({
        path: `/organizations/${code}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name DeleteOrganization
     * @summary Удалить карточку организации по коду
     * @request DELETE:/organizations/{code}
     * @secure
     */
    deleteOrganization: (code: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/organizations/${code}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  organizationTypes = {
    /**
     * No description
     *
     * @name GetOrganizationTypes
     * @summary Получить справочник типов организаций
     * @request GET:/organizationTypes
     * @secure
     */
    getOrganizationTypes: (params: RequestParams = {}) =>
      this.request<OrganizationTypeDto[], ErrorResponse>({
        path: `/organizationTypes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  organizationBusinessTypes = {
    /**
     * No description
     *
     * @name GetOrganizationBusinessTypes
     * @summary Получить справочник бизнес-типов организаций
     * @request GET:/organizationBusinessTypes
     * @secure
     */
    getOrganizationBusinessTypes: (params: RequestParams = {}) =>
      this.request<any[], ErrorResponse>({
        path: `/organizationBusinessTypes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  companyReports = {
    /**
     * No description
     *
     * @name GetReportPackageInfo
     * @summary Получить информацию о пакете/отчете
     * @request GET:/companyReports/reportPackageInfoByName
     * @secure
     */
    getReportPackageInfo: (
      query: {
        reportPackageCode: string;
        reportCodeExt?: string;
        reportVersionCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ReportPackageInfoDto, ErrorResponse>({
        path: `/companyReports/reportPackageInfoByName`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCompanyReport
     * @summary Получить реестр публикаций для компании
     * @request GET:/companyReports/companyReportByOrganizationCode/{organizationCode}
     * @secure
     */
    getCompanyReport: (organizationCode: string, params: RequestParams = {}) =>
      this.request<CompanyReportDto, ErrorResponse>({
        path: `/companyReports/companyReportByOrganizationCode/${organizationCode}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCompanyReportsTree
     * @summary Получить структуру отчётности компании
     * @request GET:/companyReports/companyReportsTree/{organizationCode}
     * @secure
     */
    getCompanyReportsTree: (organizationCode: string, params: RequestParams = {}) =>
      this.request<CompanyReportDto, ErrorResponse>({
        path: `/companyReports/companyReportsTree/${organizationCode}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ControlGroups
     * @name GetControlReportByOrganizationCode
     * @summary Получить реестр публикаций с группами контролей для компании
     * @request GET:/companyReports/companyReportWithControlsByOrganizationCode/{organizationCode}
     * @secure
     */
    getControlReportByOrganizationCode: (organizationCode: string, params: RequestParams = {}) =>
      this.request<CompanyControlReportDto, ErrorResponse>({
        path: `/companyReports/companyReportWithControlsByOrganizationCode/${organizationCode}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  companies = {
    /**
     * No description
     *
     * @name GetCompanies
     * @summary Получить список юридических лиц
     * @request GET:/companies
     * @secure
     */
    getCompanies: (
      query?: {
        counterparty?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<CompanyDto[], ErrorResponse>({
        path: `/companies`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name AddCompany
     * @summary Сохранить юридическое лицо
     * @request POST:/companies
     * @secure
     */
    addCompany: (data: CompanyDto, params: RequestParams = {}) =>
      this.request<CompanyDto, any>({
        path: `/companies`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateCompany
     * @summary Обновить юридическое лицо
     * @request PUT:/companies
     * @secure
     */
    updateCompany: (data: CompanyDto, params: RequestParams = {}) =>
      this.request<CompanyDto, any>({
        path: `/companies`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name DeleteCompany
     * @summary Удалить юридическое лицо
     * @request DELETE:/companies
     * @secure
     */
    deleteCompany: (data: CompanyDto, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/companies`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name GetAvailableCompaniesByCode
     * @summary Получить список юридических лиц с заданным ИНН
     * @request GET:/companies/available/{code}
     * @secure
     */
    getAvailableCompaniesByCode: (code: string, params: RequestParams = {}) =>
      this.request<CompanyDto[], ErrorResponse>({
        path: `/companies/available/${code}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCompanyCardByCodes
     * @summary Получить карточку компании
     * @request GET:/companies/byCodes
     * @secure
     */
    getCompanyCardByCodes: (
      query: {
        code: string;
        counterpartyTypeCode: string;
        orgLocal?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CompanyDto, any>({
        path: `/companies/byCodes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  counterpartyTypes = {
    /**
     * No description
     *
     * @name GetCounterPartyTypes
     * @summary Получить список типов контрагентов
     * @request GET:/counterpartyTypes
     * @secure
     */
    getCounterPartyTypes: (params: RequestParams = {}) =>
      this.request<CounterPartyTypeDto[], ErrorResponse>({
        path: `/counterpartyTypes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  reportPublish = {
    /**
     * No description
     *
     * @name AddReportPublish
     * @summary Загрузить новую запись в реестр публикаций
     * @request POST:/reportPublish
     * @secure
     */
    addReportPublish: (data: ReportPublishDto, params: RequestParams = {}) =>
      this.request<ReportPublishDto, ErrorResponse>({
        path: `/reportPublish`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateReportPublish
     * @summary Обновить статус и пользователя у отчёта
     * @request PUT:/reportPublish
     * @secure
     */
    updateReportPublish: (data: ReportPublishDto, params: RequestParams = {}) =>
      this.request<ReportPublishDto, ErrorResponse>({
        path: `/reportPublish`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name CleanReport
     * @summary Очистить отчёт по его коду и версии
     * @request DELETE:/reportPublish
     * @secure
     */
    cleanReport: (
      query: {
        reportPackageCode: string;
        reportVersionCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/reportPublish`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),
  };
  reportPackage = {
    /**
     * No description
     *
     * @name GetReportPackagesByCode
     * @summary Получить декларации
     * @request GET:/reportPackage
     * @secure
     */
    getReportPackagesByCode: (
      query: {
        reportPackageCode: string;
        reportVersionCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any[], ErrorResponse>({
        path: `/reportPackage`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name AddReportPackage
     * @summary Загрузить новый пакет отчётов
     * @request POST:/reportPackage
     * @secure
     */
    addReportPackage: (data: ReportPackageAddonDto, params: RequestParams = {}) =>
      this.request<ReportPackageAddonDto, ErrorResponse>({
        path: `/reportPackage`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateReportPackage
     * @summary Обновить пакет отчётов
     * @request PUT:/reportPackage
     * @secure
     */
    updateReportPackage: (data: ReportPackageAddonDto, params: RequestParams = {}) =>
      this.request<ReportPackageAddonDto, ErrorResponse>({
        path: `/reportPackage`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name CleanReportPackageByCode
     * @summary Очистить пакет по его коду
     * @request DELETE:/reportPackage
     * @secure
     */
    cleanReportPackageByCode: (
      query: {
        reportPackageCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/reportPackage`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name GetReportPackageByOrganizationCode
     * @summary Получить все пакеты отчетов по коду организации
     * @request GET:/reportPackage/{organizationCode}
     * @secure
     */
    getReportPackageByOrganizationCode: (organizationCode: string, params: RequestParams = {}) =>
      this.request<ReportPackageAddonDto[], any>({
        path: `/reportPackage/${organizationCode}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name DeleteReportPackageByCode
     * @summary Удалить пакет по его коду
     * @request DELETE:/reportPackage/{reportPackageCode}
     * @secure
     */
    deleteReportPackageByCode: (reportPackageCode: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/reportPackage/${reportPackageCode}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name SendReportPackageOnApprove
     * @summary Направить пакет на утверждение
     * @request GET:/reportPackage/status/{reportPackageCode}
     * @secure
     */
    sendReportPackageOnApprove: (reportPackageCode: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/reportPackage/status/${reportPackageCode}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateReportPackageStatus
     * @summary Утвердить или отклонить раннее направленный на утверждение пакет
     * @request PUT:/reportPackage/status/{reportPackageCode}
     * @secure
     */
    updateReportPackageStatus: (
      reportPackageCode: string,
      query: {
        status: string;
        /** Признак. isTrue - публиковать без данных; isFalse - не публиковать */
        noData: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<string[], ErrorResponse>({
        path: `/reportPackage/status/${reportPackageCode}`,
        method: 'PUT',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name ReturnReportPackageToWork
     * @summary Вернуть утверждённый ранее пакет в работу
     * @request GET:/reportPackage/status/toWork/{reportPackageCode}
     * @secure
     */
    returnReportPackageToWork: (reportPackageCode: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/reportPackage/status/toWork/${reportPackageCode}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name GetReportPackageCodesByYear
     * @summary Возвращает коды пакета отчетности
     * @request GET:/reportPackage/code/{year}
     * @secure
     */
    getReportPackageCodesByYear: (
      year?: number,
      query?: {
        group?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<string[], ErrorResponse>({
        path: `/reportPackage/code/${year}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetReportPackageByDeclarationRegNumber
     * @request GET:/reportPackage/byDeclarationRegNumber/{declarationRegNumber}
     * @secure
     */
    getReportPackageByDeclarationRegNumber: (declarationRegNumber: string, params: RequestParams = {}) =>
      this.request<string[], ErrorResponse>({
        path: `/reportPackage/byDeclarationRegNumber/${declarationRegNumber}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  integration = {
    /**
     * No description
     *
     * @name TransferData
     * @summary Запустить перенос данных
     * @request GET:/integration/sap
     * @secure
     */
    transferData: (
      query: {
        reportPackageCode: string;
        reportVersionCode?: string[];
        /**
         * @format int32
         * @default 50000
         */
        pageSize?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, ErrorResponse>({
        path: `/integration/sap`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  xml = {
    /**
     * No description
     *
     * @name PostXml
     * @summary Загрузить XML файл
     * @request POST:/xml
     * @secure
     */
    postXml: (
      data: {
        /** @example "COMPANY_ACCY2021P34С0" */
        packageCode?: string;
        /** @example 1151006 */
        versionCode?: string;
        /** @format binary */
        file?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<object, ErrorResponse>({
        path: `/xml`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),
  };
  getExcel = {
    /**
     * No description
     *
     * @name GetExcel
     * @summary Получить excel для выбранной таблицы
     * @request GET:/getExcel/{organizationName}/{reportPackageCode}/{reportVersionCode}
     * @secure
     */
    getExcel: (
      organizationName: string,
      reportPackageCode: string,
      reportVersionCode: string,
      params: RequestParams = {},
    ) =>
      this.request<File, ErrorResponse>({
        path: `/getExcel/${organizationName}/${reportPackageCode}/${reportVersionCode}`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  };
  uploadExcel = {
    /**
     * No description
     *
     * @name UploadExcel
     * @summary Загрузить excel файл
     * @request POST:/uploadExcel
     * @secure
     */
    uploadExcel: (data: ExcelInputDto, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/uploadExcel`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  uncreatedReports = {
    /**
     * No description
     *
     * @name GetUncreatedReports
     * @summary Получить отчёты, которые возможно добавить в пакет
     * @request GET:/uncreatedReports
     * @secure
     */
    getUncreatedReports: (
      query: {
        reportPackageCode: string;
        organizationCode: string;
        reportGroupCode: string;
        periodCode: string;
        /** @format int32 */
        reportPackageYear: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<UncreatedReportDto[], any>({
        path: `/uncreatedReports`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name AddUncreatedReportsIntoPackage
     * @summary Добавить отчёты в пакет
     * @request POST:/uncreatedReports
     * @secure
     */
    addUncreatedReportsIntoPackage: (data: ReportPublishDto[], params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/uncreatedReports`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  uncreatedControls = {
    /**
     * No description
     *
     * @name GetUncreatedControlVersions
     * @summary Получить контроли, которые возможно добавить в пакет
     * @request GET:/uncreatedControls
     * @secure
     */
    getUncreatedControlVersions: (
      query: {
        reportPackageCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ControlVersionWithNameDto[], any>({
        path: `/uncreatedControls`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name AddUncreatedControlVersionsIntoPackage
     * @summary Добавить контроли в пакет
     * @request POST:/uncreatedControls
     * @secure
     */
    addUncreatedControlVersionsIntoPackage: (data: UncreatedControlVersionDto, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/uncreatedControls`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  reportGroups = {
    /**
     * No description
     *
     * @name GetReportGroups
     * @summary Получить все группы отчетов
     * @request GET:/reportGroups
     * @secure
     */
    getReportGroups: (
      query?: {
        regulated?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<any[], any>({
        path: `/reportGroups`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Создать Группу отчетов
     *
     * @name AddReportGroup
     * @request POST:/reportGroups
     * @secure
     */
    addReportGroup: (data: any, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/reportGroups`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Обновить группу отчетов
     *
     * @name UpdateReportGroup
     * @request PUT:/reportGroups
     * @secure
     */
    updateReportGroup: (data: any, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/reportGroups`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetReportGroup
     * @summary Получить группу отчетов
     * @request GET:/reportGroups/{code}
     * @secure
     */
    getReportGroup: (
      code: string,
      query: {
        regulated: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, ErrorResponse>({
        path: `/reportGroups/${code}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Удалить группу отчета
     *
     * @name DeleteReportGroup
     * @request DELETE:/reportGroups/{code}
     * @secure
     */
    deleteReportGroup: (code: string[], params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/reportGroups/${code}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  reportPeriods = {
    /**
     * No description
     *
     * @name GetReportPeriods
     * @summary Получить список периодов (Справочник "Календарь отчетных форм")
     * @request GET:/reportPeriods
     * @secure
     */
    getReportPeriods: (params: RequestParams = {}) =>
      this.request<ReportPeriodDto[], ErrorResponse>({
        path: `/reportPeriods`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Создать запись в справочнике "Календарь отчетных форм"
     *
     * @name AddReportPeriod
     * @request POST:/reportPeriods
     * @secure
     */
    addReportPeriod: (data: ReportPeriodDto, params: RequestParams = {}) =>
      this.request<ReportPeriodDto, any>({
        path: `/reportPeriods`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Удалить справочник "Календарь отчетных форм"
     *
     * @name DeleteReportPeriods
     * @request DELETE:/reportPeriods
     * @secure
     */
    deleteReportPeriods: (data: ReportPeriodDto[], params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/reportPeriods`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name GetReportPeriod
     * @summary Получить запись из справочника "Календарь отчетных форм"
     * @request GET:/reportPeriods/{reportGroupCode}/{periodCode}
     * @secure
     */
    getReportPeriod: (reportGroupCode: string, periodCode: string, params: RequestParams = {}) =>
      this.request<ReportPeriodDto, ErrorResponse>({
        path: `/reportPeriods/${reportGroupCode}/${periodCode}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Обновить справочник "Календарь отчетных форм"
     *
     * @name UpdateReportPeriod
     * @request PUT:/reportPeriods/{reportGroupCode}/{periodCode}
     * @secure
     */
    updateReportPeriod: (
      reportGroupCode: string,
      periodCode: string,
      data: ReportPeriodDto,
      params: RequestParams = {},
    ) =>
      this.request<ReportPeriodDto, any>({
        path: `/reportPeriods/${reportGroupCode}/${periodCode}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  periods = {
    /**
     * No description
     *
     * @name GetPeriods
     * @summary Получить список периодов
     * @request GET:/periods
     * @secure
     */
    getPeriods: (params: RequestParams = {}) =>
      this.request<PeriodDto[], ErrorResponse>({
        path: `/periods`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  calculate = {
    /**
     * No description
     *
     * @name CalculateData
     * @summary Запустить процесс расчёта
     * @request POST:/calculate
     * @secure
     */
    calculateData: (data: CalculationRequestDto, params: RequestParams = {}) =>
      this.request<EtlProcessDto, ErrorResponse>({
        path: `/calculate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  etlProcesses = {
    /**
     * No description
     *
     * @name GetEtlProcesses
     * @summary Получить журнал ETL процессов
     * @request GET:/etlProcesses
     * @secure
     */
    getEtlProcesses: (params: RequestParams = {}) =>
      this.request<EtlProcessDto[], ErrorResponse>({
        path: `/etlProcesses`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetEtlLogsByGuid
     * @summary Получить журнал логов ETL процесса по guid
     * @request GET:/etlProcesses/logs/{etlGuid}
     * @secure
     */
    getEtlLogsByGuid: (etlGuid: string, params: RequestParams = {}) =>
      this.request<EtlLogDto[], ErrorResponse>({
        path: `/etlProcesses/logs/${etlGuid}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetActiveEtlProcesses
     * @summary Получить активные процессы
     * @request GET:/etlProcesses/active
     * @secure
     */
    getActiveEtlProcesses: (params: RequestParams = {}) =>
      this.request<EtlProcessDto[], ErrorResponse>({
        path: `/etlProcesses/active`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetEtlTypes
     * @summary Получить справочник типов ETL процессов
     * @request GET:/etlProcesses/etlTypes
     * @secure
     */
    getEtlTypes: (params: RequestParams = {}) =>
      this.request<EtlTypeDto[], ErrorResponse>({
        path: `/etlProcesses/etlTypes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetEtlProcessByGuid
     * @summary Получить ETL процесс по guid
     * @request GET:/etlProcesses/proccess/{etlGuid}
     * @secure
     */
    getEtlProcessByGuid: (etlGuid: string, params: RequestParams = {}) =>
      this.request<EtlProcessDto, ErrorResponse>({
        path: `/etlProcesses/proccess/${etlGuid}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  frequency = {
    /**
     * No description
     *
     * @name GetFrequencies
     * @summary Получить справочник частотности
     * @request GET:/frequency
     * @secure
     */
    getFrequencies: (params: RequestParams = {}) =>
      this.request<FrequencyDto[], ErrorResponse>({
        path: `/frequency`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  month = {
    /**
     * No description
     *
     * @name GetMonths
     * @summary Получить справочник месяцев
     * @request GET:/month
     * @secure
     */
    getMonths: (params: RequestParams = {}) =>
      this.request<MonthDto[], ErrorResponse>({
        path: `/month`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  keycloak = {
    /**
     * No description
     *
     * @name Login
     * @request POST:/keycloak/login
     * @secure
     */
    login: (data: CredentialsDto, params: RequestParams = {}) =>
      this.request<any, ErrorResponse>({
        path: `/keycloak/login`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  report = {
    /**
     * No description
     *
     * @name GetReports
     * @summary Получить справочник отчетов
     * @request GET:/report
     * @secure
     */
    getReports: (params: RequestParams = {}) =>
      this.request<ReportDto[], any>({
        path: `/report`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Создать справочник отчетов
     *
     * @name AddReport
     * @request POST:/report
     * @secure
     */
    addReport: (data: ReportDto, params: RequestParams = {}) =>
      this.request<ReportDto, any>({
        path: `/report`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Обновить справочник отчетов
     *
     * @name UpdateReport
     * @request PUT:/report
     * @secure
     */
    updateReport: (data: ReportDto, params: RequestParams = {}) =>
      this.request<ReportDto, any>({
        path: `/report`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetReport
     * @summary Получить справочник отчетов
     * @request GET:/report/{code}
     * @secure
     */
    getReport: (code: string, params: RequestParams = {}) =>
      this.request<ReportDto, ErrorResponse>({
        path: `/report/${code}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Удалить справочник отчетов
     *
     * @name DeleteReport
     * @request DELETE:/report/{code}
     * @secure
     */
    deleteReport: (code: string[], params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/report/${code}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  reportVersions = {
    /**
     * No description
     *
     * @name GetReportVersions
     * @summary Получить справочник версии отчетов
     * @request GET:/reportVersions
     * @secure
     */
    getReportVersions: (
      query?: {
        /** @default false */
        withStructure?: boolean;
        organizationCode?: string;
        reportGroupCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ReportVersionDto[], any>({
        path: `/reportVersions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Создать справочник версии отчетов
     *
     * @name AddReportVersion
     * @request POST:/reportVersions
     * @secure
     */
    addReportVersion: (data: ReportVersionDto, params: RequestParams = {}) =>
      this.request<ReportVersionDto, any>({
        path: `/reportVersions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Обновить справочник версии отчетов
     *
     * @name UpdateReportVersion
     * @request PUT:/reportVersions
     * @secure
     */
    updateReportVersion: (data: ReportVersionDto, params: RequestParams = {}) =>
      this.request<ReportVersionDto, any>({
        path: `/reportVersions`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetReportVersion
     * @summary Получить справочник версии отчетов
     * @request GET:/reportVersions/{code}
     * @secure
     */
    getReportVersion: (code: string, params: RequestParams = {}) =>
      this.request<ReportVersionDto, ErrorResponse>({
        path: `/reportVersions/${code}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Удалить справочник версии отчетов
     *
     * @name DeleteReportVersion
     * @request DELETE:/reportVersions/{code}
     * @secure
     */
    deleteReportVersion: (code: string[], params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/reportVersions/${code}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  reportTypes = {
    /**
     * No description
     *
     * @name GetReportTypes
     * @summary Получить все типы отчетов
     * @request GET:/reportTypes
     * @secure
     */
    getReportTypes: (params: RequestParams = {}) =>
      this.request<ReportTypeDto[], any>({
        path: `/reportTypes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Создать Тип отчета
     *
     * @name AddReportType
     * @request POST:/reportTypes
     * @secure
     */
    addReportType: (data: ReportTypeDto, params: RequestParams = {}) =>
      this.request<ReportTypeDto, any>({
        path: `/reportTypes`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Обновить список юридических лиц
     *
     * @name UpdateReportType
     * @request PUT:/reportTypes
     * @secure
     */
    updateReportType: (data: ReportTypeDto, params: RequestParams = {}) =>
      this.request<ReportTypeDto, any>({
        path: `/reportTypes`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetReportType
     * @summary Получить Тип отчета
     * @request GET:/reportTypes/{code}
     * @secure
     */
    getReportType: (code: string, params: RequestParams = {}) =>
      this.request<ReportTypeDto, ErrorResponse>({
        path: `/reportTypes/${code}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Удалить тип отчета
     *
     * @name DeleteReportType
     * @request DELETE:/reportTypes/{code}
     * @secure
     */
    deleteReportType: (code: string[], params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/reportTypes/${code}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  reportSettings = {
    /**
     * No description
     *
     * @name GetReportSetting
     * @summary Получить настройки отчета
     * @request GET:/reportSettings/{organizationCode}/{reportVersionCode}
     * @secure
     */
    getReportSetting: (organizationCode: string, reportVersionCode: string, params: RequestParams = {}) =>
      this.request<ReportSettingDto, ErrorResponse>({
        path: `/reportSettings/${organizationCode}/${reportVersionCode}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetReportSettingsByOrganization
     * @summary Получить настройки отчета
     * @request GET:/reportSettings/{organizationCode}
     * @secure
     */
    getReportSettingsByOrganization: (organizationCode: string, params: RequestParams = {}) =>
      this.request<ReportSettingDto[], ErrorResponse>({
        path: `/reportSettings/${organizationCode}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetReportSettingLevel
     * @summary Получить поля из справочника с перечнем Level для настройки отчетов
     * @request GET:/reportSettings/level
     * @secure
     */
    getReportSettingLevel: (params: RequestParams = {}) =>
      this.request<ReportSettingLevelDto[], ErrorResponse>({
        path: `/reportSettings/level`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Создать настройки отчета
     *
     * @name AddReportSettings
     * @request POST:/reportSettings
     * @secure
     */
    addReportSettings: (data: ReportSettingDto, params: RequestParams = {}) =>
      this.request<ReportSettingDto, any>({
        path: `/reportSettings`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Обновить настройки отчета
     *
     * @name UpdateReportSettings
     * @request PUT:/reportSettings
     * @secure
     */
    updateReportSettings: (data: ReportSettingDto, params: RequestParams = {}) =>
      this.request<ReportSettingDto, any>({
        path: `/reportSettings`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Удалить настройки отчета
     *
     * @name DeleteReportSettings
     * @request DELETE:/reportSettings
     * @secure
     */
    deleteReportSettings: (data: ReportSettingsDeleteDto[], params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/reportSettings`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  reportStructures = {
    /**
     * No description
     *
     * @name GetReportStructures
     * @summary Получить информацию о cтруктуре отчета
     * @request GET:/reportStructures/reportStructuresByReportVersionCode
     * @secure
     */
    getReportStructures: (
      query: {
        organizationCode: string;
        reportVersionCode: string;
        reportPackageCode: string;
        reportCode?: string;
        taxTypeCode?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ReportStructureDto[], ErrorResponse>({
        path: `/reportStructures/reportStructuresByReportVersionCode`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetDisclosureReport
     * @summary Получить информацию об отчете раскрытия
     * @request GET:/reportStructures/disclosureReportByParams
     * @secure
     */
    getDisclosureReport: (
      query: {
        organizationCode: string;
        reportVersionCode: string;
        code: string;
        reportPackageCode: string;
        reportCode?: string;
        reportName?: string;
        taxTypeCode?: string;
        taxTypeName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DisclosureReportDto[], ErrorResponse>({
        path: `/reportStructures/disclosureReportByParams`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  infoSystems = {
    /**
     * No description
     *
     * @name GetInfoSystems
     * @summary Получить справочник информационных систем
     * @request GET:/infoSystems
     * @secure
     */
    getInfoSystems: (params: RequestParams = {}) =>
      this.request<InfoSystemDto[], ErrorResponse>({
        path: `/infoSystems`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  sourceTypes = {
    /**
     * No description
     *
     * @name GetSourceTypes
     * @summary Получить справочник типов
     * @request GET:/sourceTypes
     * @secure
     */
    getSourceTypes: (params: RequestParams = {}) =>
      this.request<SourceTypeDto[], ErrorResponse>({
        path: `/sourceTypes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  account = {
    /**
     * No description
     *
     * @name GetAccountInfo
     * @summary Получить данные по аккаунту пользователю
     * @request GET:/account
     * @secure
     */
    getAccountInfo: (params: RequestParams = {}) =>
      this.request<AccountInfoDto, ErrorResponse>({
        path: `/account`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  tableComponentV2 = {
    /**
     * No description
     *
     * @name GetTableJson
     * @summary Получить таблицу по заданным параметрам
     * @request POST:/tableComponentV2
     * @secure
     */
    getTableJson: (data: TableComponentRequestDto, params: RequestParams = {}) =>
      this.request<string, ErrorResponse>({
        path: `/tableComponentV2`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name OperateSelected
     * @summary Выполнить операцию над выделенными строками
     * @request POST:/tableComponentV2/operate
     * @secure
     */
    operateSelected: (data: TableComponentRequestDto, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/tableComponentV2/operate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name CountSelected
     * @summary Подсчитать количество строк в выделении
     * @request POST:/tableComponentV2/countSelected
     * @secure
     */
    countSelected: (data: TableComponentRequestDto, params: RequestParams = {}) =>
      this.request<number, ErrorResponse>({
        path: `/tableComponentV2/countSelected`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  tableMetaData = {
    /**
     * No description
     *
     * @name GetTableMetaData
     * @summary Получить информация о колонках в таблице
     * @request POST:/tableMetaData
     * @secure
     */
    getTableMetaData: (data: any, params: RequestParams = {}) =>
      this.request<any, ErrorResponse>({
        path: `/tableMetaData`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  controls = {
    /**
     * No description
     *
     * @tags Controls
     * @name GetControls
     * @summary Получить список всех контролей
     * @request GET:/controls
     * @secure
     */
    getControls: (params: RequestParams = {}) =>
      this.request<ControlDto[], ErrorResponse>({
        path: `/controls`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Controls
     * @name AddControl
     * @summary Сохранить новый контроль
     * @request POST:/controls
     * @secure
     */
    addControl: (data: ControlDto, params: RequestParams = {}) =>
      this.request<ControlDto, ErrorResponse>({
        path: `/controls`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Controls
     * @name UpdateControlByCode
     * @summary Обновить существующий контроль по коду
     * @request PUT:/controls
     * @secure
     */
    updateControlByCode: (data: ControlDto, params: RequestParams = {}) =>
      this.request<ControlDto, ErrorResponse>({
        path: `/controls`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Controls
     * @name GetControlByCtrlCode
     * @summary Получить контроль по коду
     * @request GET:/controls/{ctrlCode}
     * @secure
     */
    getControlByCtrlCode: (ctrlCode: string, params: RequestParams = {}) =>
      this.request<ControlDto, ErrorResponse>({
        path: `/controls/${ctrlCode}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Controls
     * @name DeleteControlByCode
     * @summary Удалить контроль по коду
     * @request DELETE:/controls/{ctrlCode}
     * @secure
     */
    deleteControlByCode: (ctrlCode: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/controls/${ctrlCode}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags RunControls
     * @name RunControls
     * @summary Запуск процедуры расчета контролей
     * @request POST:/controls/runControls
     * @secure
     */
    runControls: (data: RunControlRequestDto, params: RequestParams = {}) =>
      this.request<string, ErrorResponse>({
        path: `/controls/runControls`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  controlSteps = {
    /**
     * @description Возвращает список всех шагов для всех версий контролей
     *
     * @tags ControlSteps
     * @name GetControlSteps
     * @request GET:/controlSteps
     * @secure
     */
    getControlSteps: (params: RequestParams = {}) =>
      this.request<ControlStepDto[], ErrorResponse>({
        path: `/controlSteps`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Сохраняет новый шаг контроля в системе
     *
     * @tags ControlSteps
     * @name AddControlStep
     * @request POST:/controlSteps
     * @secure
     */
    addControlStep: (data: ControlStepDto, params: RequestParams = {}) =>
      this.request<ControlStepDto, ErrorResponse>({
        path: `/controlSteps`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Обновляет данные шага контроля
     *
     * @tags ControlSteps
     * @name UpdateControlStep
     * @request PUT:/controlSteps
     * @secure
     */
    updateControlStep: (data: ControlStepDto, params: RequestParams = {}) =>
      this.request<ControlStepDto, ErrorResponse>({
        path: `/controlSteps`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Возвращает список всех шагов, принадлежащих указанной версии контроля
     *
     * @tags ControlSteps
     * @name GetControlStepsByVersion
     * @request GET:/controlSteps/{ctrlVersCode}
     * @secure
     */
    getControlStepsByVersion: (ctrlVersCode: string, params: RequestParams = {}) =>
      this.request<ControlStepDto[], ErrorResponse>({
        path: `/controlSteps/${ctrlVersCode}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Возвращает шаг контроля
     *
     * @tags ControlSteps
     * @name GetControlStepByVersionAndNum
     * @request GET:/controlSteps/{ctrlVersCode}/{stepNum}
     * @secure
     */
    getControlStepByVersionAndNum: (ctrlVersCode: string, stepNum: number, params: RequestParams = {}) =>
      this.request<ControlStepDto, ErrorResponse>({
        path: `/controlSteps/${ctrlVersCode}/${stepNum}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Удаляет шаг контроля
     *
     * @tags ControlSteps
     * @name DeleteControlStepByVersionAndNum
     * @request DELETE:/controlSteps/{ctrlVersCode}/{stepNum}
     * @secure
     */
    deleteControlStepByVersionAndNum: (ctrlVersCode: string, stepNum: number, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/controlSteps/${ctrlVersCode}/${stepNum}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  controlStepLogics = {
    /**
     * @description Возвращает список всей логики для всех шагов всех версий контролей
     *
     * @tags ControlStepLogics
     * @name GetControlStepLogics
     * @summary Получить список всей логики шагов контроля
     * @request GET:/controlStepLogics
     * @secure
     */
    getControlStepLogics: (params: RequestParams = {}) =>
      this.request<ControlStepLogicDto[], ErrorResponse>({
        path: `/controlStepLogics`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Сохраняет новую запись логики для шага контроля
     *
     * @tags ControlStepLogics
     * @name AddControlStepLogic
     * @summary Создать новую запись логики шага контроля
     * @request POST:/controlStepLogics
     * @secure
     */
    addControlStepLogic: (data: ControlStepLogicDto, params: RequestParams = {}) =>
      this.request<ControlStepLogicDto, ErrorResponse>({
        path: `/controlStepLogics`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Обновляет данные логики шага контроля
     *
     * @tags ControlStepLogics
     * @name UpdateControlStepLogic
     * @summary Обновить существующую логику шага контроля
     * @request PUT:/controlStepLogics
     * @secure
     */
    updateControlStepLogic: (data: ControlStepLogicDto, params: RequestParams = {}) =>
      this.request<ControlStepLogicDto, ErrorResponse>({
        path: `/controlStepLogics`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Возвращает список всей логики шагов, принадлежащих указанной версии контроля
     *
     * @tags ControlStepLogics
     * @name GetControlStepLogicsByVersion
     * @summary Получить всю логику шагов для версии контроля
     * @request GET:/controlStepLogics/{ctrlVersCode}
     * @secure
     */
    getControlStepLogicsByVersion: (ctrlVersCode: string, params: RequestParams = {}) =>
      this.request<ControlStepLogicDto[], ErrorResponse>({
        path: `/controlStepLogics/${ctrlVersCode}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Возвращает одну запись логики шага контроля
     *
     * @tags ControlStepLogics
     * @name GetControlStepLogicByVersionAndNum
     * @summary Найти логику конкретного шага контроля по версии и номеру
     * @request GET:/controlStepLogics/{ctrlVersCode}/{stepNum}
     * @secure
     */
    getControlStepLogicByVersionAndNum: (ctrlVersCode: string, stepNum: number, params: RequestParams = {}) =>
      this.request<ControlStepLogicDto, ErrorResponse>({
        path: `/controlStepLogics/${ctrlVersCode}/${stepNum}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Удаляет одну запись логики шага контроля
     *
     * @tags ControlStepLogics
     * @name DeleteControlStepLogicByVersionAndNum
     * @summary Удалить логику шага контроля по версии и номеру
     * @request DELETE:/controlStepLogics/{ctrlVersCode}/{stepNum}
     * @secure
     */
    deleteControlStepLogicByVersionAndNum: (ctrlVersCode: string, stepNum: number, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/controlStepLogics/${ctrlVersCode}/${stepNum}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  controlVersions = {
    /**
     * @description Возвращает список всех версий для всех существующих контролей
     *
     * @tags ControlVersions
     * @name GetControlVersions
     * @summary Получить список всех версий контролей
     * @request GET:/controlVersions
     * @secure
     */
    getControlVersions: (params: RequestParams = {}) =>
      this.request<ControlVersionDto[], ErrorResponse>({
        path: `/controlVersions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Сохраняет новую версию контроля
     *
     * @tags ControlVersions
     * @name AddControlVersion
     * @summary Создать новую версию контроля
     * @request POST:/controlVersions
     * @secure
     */
    addControlVersion: (data: ControlVersionDto, params: RequestParams = {}) =>
      this.request<ControlVersionDto, ErrorResponse>({
        path: `/controlVersions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Обновляет данные версии контроля
     *
     * @tags ControlVersions
     * @name UpdateControlVersion
     * @summary Обновить существующую версию контроля
     * @request PUT:/controlVersions
     * @secure
     */
    updateControlVersion: (data: ControlVersionDto, params: RequestParams = {}) =>
      this.request<ControlVersionDto, ErrorResponse>({
        path: `/controlVersions`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Возвращает одну версию контроля
     *
     * @tags ControlVersions
     * @name GetControlVersionByCtrlVersCode
     * @summary Найти конкретную версию контроля по коду версии
     * @request GET:/controlVersions/{ctrlVersCode}
     * @secure
     */
    getControlVersionByCtrlVersCode: (ctrlVersCode: string, params: RequestParams = {}) =>
      this.request<ControlVersionDto, ErrorResponse>({
        path: `/controlVersions/${ctrlVersCode}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Удаляет одну версию контроля
     *
     * @tags ControlVersions
     * @name DeleteControlVersionByCtrlVersCode
     * @summary Удалить версию контроля по её коду
     * @request DELETE:/controlVersions/{ctrlVersCode}
     * @secure
     */
    deleteControlVersionByCtrlVersCode: (ctrlVersCode: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/controlVersions/${ctrlVersCode}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  indicators = {
    /**
     * @description Возвращает список всех определенных показателей
     *
     * @tags Indicators
     * @name GetIndicators
     * @summary Получить список всех показателей
     * @request GET:/indicators
     * @secure
     */
    getIndicators: (params: RequestParams = {}) =>
      this.request<IndicatorDto[], ErrorResponse>({
        path: `/indicators`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Сохраняет новые показатели
     *
     * @tags Indicators
     * @name AddIndicators
     * @summary Создать новые показатели
     * @request POST:/indicators
     * @secure
     */
    addIndicators: (data: IndicatorDto[], params: RequestParams = {}) =>
      this.request<IndicatorDto[], ErrorResponse>({
        path: `/indicators`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Обновляет данные показателей
     *
     * @tags Indicators
     * @name UpdateIndicators
     * @summary Обновить существующие показатели
     * @request PUT:/indicators
     * @secure
     */
    updateIndicators: (data: IndicatorDto[], params: RequestParams = {}) =>
      this.request<IndicatorDto[], ErrorResponse>({
        path: `/indicators`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Возвращает показатель
     *
     * @tags Indicators
     * @name GetIndicatorByVarCode
     * @summary Найти показатель по коду
     * @request GET:/indicators/{varCode}
     * @secure
     */
    getIndicatorByVarCode: (varCode: string, params: RequestParams = {}) =>
      this.request<IndicatorDto, ErrorResponse>({
        path: `/indicators/${varCode}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Удаляет показатели
     *
     * @tags Indicators
     * @name DeleteIndicatorsByCode
     * @summary Удалить показатели по коду
     * @request DELETE:/indicators/{varCode}
     * @secure
     */
    deleteIndicatorsByCode: (varCode: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/indicators/${varCode}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Удаляет показатель
     *
     * @tags Indicators
     * @name DeleteIndicatorByCodeAndGroups
     * @summary Удалить показатель по коду, группе выборки, условию выборки
     * @request DELETE:/indicators/{varCode}/{orGroup}/{andGroup}
     * @secure
     */
    deleteIndicatorByCodeAndGroups: (varCode: string, orGroup: number, andGroup: number, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/indicators/${varCode}/${orGroup}/${andGroup}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Возвращает список всех источников данных для показателей
     *
     * @tags VarSources
     * @name GetVarSources
     * @summary Получить список всех источников данных для показателей
     * @request GET:/indicators/varSources
     * @secure
     */
    getVarSources: (params: RequestParams = {}) =>
      this.request<VarSourceDto[], ErrorResponse>({
        path: `/indicators/varSources`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Возвращает список всех функций агрегации
     *
     * @tags AggFuncs
     * @name GetAggFuncs
     * @summary Получить список всех функций агрегации
     * @request GET:/indicators/aggFuncs
     * @secure
     */
    getAggFuncs: (params: RequestParams = {}) =>
      this.request<AggFuncDto[], ErrorResponse>({
        path: `/indicators/aggFuncs`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  stepTypes = {
    /**
     * No description
     *
     * @tags StepTypes
     * @name GetStepTypes
     * @summary Получить список всех типов шагов
     * @request GET:/stepTypes
     * @secure
     */
    getStepTypes: (params: RequestParams = {}) =>
      this.request<StepTypeDto[], ErrorResponse>({
        path: `/stepTypes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags StepTypes
     * @name AddStepType
     * @summary Сохранить новый тип шага
     * @request POST:/stepTypes
     * @secure
     */
    addStepType: (data: StepTypeDto, params: RequestParams = {}) =>
      this.request<StepTypeDto, ErrorResponse>({
        path: `/stepTypes`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags StepTypes
     * @name UpdateStepType
     * @summary Обновить существующий тип шага
     * @request PUT:/stepTypes
     * @secure
     */
    updateStepType: (data: StepTypeDto, params: RequestParams = {}) =>
      this.request<StepTypeDto, ErrorResponse>({
        path: `/stepTypes`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags StepTypes
     * @name DeleteStepType
     * @summary Удалить тип шага
     * @request DELETE:/stepTypes/{type}
     * @secure
     */
    deleteStepType: (type: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/stepTypes/${type}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  tableFieldsInfo = {
    /**
     * No description
     *
     * @name GetTableFieldsInfo
     * @summary Получение информации о колонках из таблицы register_meta
     * @request GET:/tableFieldsInfo/{reportVersionCode}
     * @secure
     */
    getTableFieldsInfo: (reportVersionCode: string, params: RequestParams = {}) =>
      this.request<TableFieldInfoDto[], ErrorResponse>({
        path: `/tableFieldsInfo/${reportVersionCode}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  filterOperators = {
    /**
     * No description
     *
     * @name GetFilterOperators
     * @summary Получить справочник опций выбора
     * @request GET:/filterOperators
     * @secure
     */
    getFilterOperators: (params: RequestParams = {}) =>
      this.request<FilterOperatorDto[], ErrorResponse>({
        path: `/filterOperators`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  controlApplicability = {
    /**
     * No description
     *
     * @tags ControlApplicability
     * @name GetControlApplicabilities
     * @summary Получить список всех применимостей контролей
     * @request GET:/controlApplicability
     * @secure
     */
    getControlApplicabilities: (params: RequestParams = {}) =>
      this.request<ControlApplicabilityDto[], ErrorResponse>({
        path: `/controlApplicability`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ControlApplicability
     * @name AddControlApplicability
     * @summary Сохранить применимость контроля
     * @request POST:/controlApplicability
     * @secure
     */
    addControlApplicability: (data: ControlApplicabilityDto, params: RequestParams = {}) =>
      this.request<ControlApplicabilityDto, ErrorResponse>({
        path: `/controlApplicability`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ControlApplicability
     * @name UpdateControlApplicability
     * @summary Обновить применимость контроля
     * @request PUT:/controlApplicability
     * @secure
     */
    updateControlApplicability: (data: ControlApplicabilityDto, params: RequestParams = {}) =>
      this.request<ControlApplicabilityDto, ErrorResponse>({
        path: `/controlApplicability`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ControlApplicability
     * @name GetControlApplicabilityByCodes
     * @summary Получить применимость контроля по кодам
     * @request GET:/controlApplicability/{ctrlVersCode}/{orgCode}
     * @secure
     */
    getControlApplicabilityByCodes: (ctrlVersCode: string, orgCode: string, params: RequestParams = {}) =>
      this.request<ControlApplicabilityDto, ErrorResponse>({
        path: `/controlApplicability/${ctrlVersCode}/${orgCode}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Controls
     * @name DeleteControlApplicabilityByCodes
     * @summary Удалить применимость контроля по кодам
     * @request DELETE:/controlApplicability/{ctrlVersCode}/{orgCode}
     * @secure
     */
    deleteControlApplicabilityByCodes: (ctrlVersCode: string, orgCode: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/controlApplicability/${ctrlVersCode}/${orgCode}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  controlGroups = {
    /**
     * No description
     *
     * @tags ControlGroups
     * @name GetControlGroups
     * @summary Получить список всех групп контролей
     * @request GET:/controlGroups
     * @secure
     */
    getControlGroups: (params: RequestParams = {}) =>
      this.request<ControlGroupDto[], ErrorResponse>({
        path: `/controlGroups`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ControlGroups
     * @name AddControlGroup
     * @summary Сохранить группу контроля
     * @request POST:/controlGroups
     * @secure
     */
    addControlGroup: (data: ControlGroupDto, params: RequestParams = {}) =>
      this.request<ControlGroupDto, ErrorResponse>({
        path: `/controlGroups`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ControlGroups
     * @name UpdateControlGroupByCode
     * @summary Обновить группу контроля
     * @request PUT:/controlGroups
     * @secure
     */
    updateControlGroupByCode: (data: ControlGroupDto, params: RequestParams = {}) =>
      this.request<ControlGroupDto, ErrorResponse>({
        path: `/controlGroups`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ControlGroups
     * @name GetControlGroupByCode
     * @summary Получить группу контролей по коду
     * @request GET:/controlGroups/{ctrlGroupCode}
     * @secure
     */
    getControlGroupByCode: (ctrlGroupCode: string, params: RequestParams = {}) =>
      this.request<ControlGroupDto, ErrorResponse>({
        path: `/controlGroups/${ctrlGroupCode}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ControlGroups
     * @name DeleteControlGroupByCode
     * @summary Удалить группу контроля по коду
     * @request DELETE:/controlGroups/{ctrlGroupCode}
     * @secure
     */
    deleteControlGroupByCode: (ctrlGroupCode: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/controlGroups/${ctrlGroupCode}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  properties = {
    /**
     * @description Получить список настроек
     *
     * @name GetProperties
     * @request GET:/properties
     * @secure
     */
    getProperties: (params: RequestParams = {}) =>
      this.request<Property[], any>({
        path: `/properties`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Обновить переменные
     *
     * @name UpdateProperties
     * @request PUT:/properties
     * @secure
     */
    updateProperties: (data: Property[], params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/properties`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Получить список настроек, доступных для UI. Возвращает список свойств, у которых `uiProperty == true`. Если value равно null, возвращается defaultValue.
     *
     * @name GetUiPropertyValue
     * @request GET:/properties/ui
     * @secure
     */
    getUiPropertyValue: (params: RequestParams = {}) =>
      this.request<Property[], any>({
        path: `/properties/ui`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  userFiltres = {
    /**
     * No description
     *
     * @name GetUserFilters
     * @summary Получить список пользователей с фильтрами
     * @request GET:/userFiltres
     * @secure
     */
    getUserFilters: (params: RequestParams = {}) =>
      this.request<UserFilterDto[], ErrorResponse>({
        path: `/userFiltres`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name ProcessUserFilters
     * @summary Обработать изменение настроек фильтров
     * @request POST:/userFiltres
     * @secure
     */
    processUserFilters: (data: UserFilterDto[], params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/userFiltres`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  admin = {
    /**
     * No description
     *
     * @name GetAdminOrganizations
     * @summary Получение оргструктуры организации из админской панели
     * @request GET:/admin/organizations
     * @secure
     */
    getAdminOrganizations: (params: RequestParams = {}) =>
      this.request<OrganizationDto[], ErrorResponse>({
        path: `/admin/organizations`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetAdminReportPeriods
     * @summary Получить список периодов (Справочник "Календарь отчетных форм") из админской панели
     * @request GET:/admin/reportPeriods
     * @secure
     */
    getAdminReportPeriods: (params: RequestParams = {}) =>
      this.request<ReportPeriodDto[], ErrorResponse>({
        path: `/admin/reportPeriods`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetAdminReportGroups
     * @summary Получить все группы отчетов из админской панели
     * @request GET:/admin/reportGroups
     * @secure
     */
    getAdminReportGroups: (params: RequestParams = {}) =>
      this.request<any[], ErrorResponse>({
        path: `/admin/reportGroups`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetAdminReportTypes
     * @summary Получить перечень отчетов из админской панели
     * @request GET:/admin/reportTypes
     * @secure
     */
    getAdminReportTypes: (params: RequestParams = {}) =>
      this.request<ReportTypeDto[], ErrorResponse>({
        path: `/admin/reportTypes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetReportUserAudit
     * @summary Получение списка пользователей и ролей
     * @request GET:/admin/reportUserAudit
     * @secure
     */
    getReportUserAudit: (params: RequestParams = {}) =>
      this.request<ReportUserAuditDto, ErrorResponse>({
        path: `/admin/reportUserAudit`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  system = {
    /**
     * No description
     *
     * @name GetAllModules
     * @summary Получение список всех модулей с детализацией по зависимым сервисами и операциям
     * @request GET:/system
     * @secure
     */
    getAllModules: (params: RequestParams = {}) =>
      this.request<AppModuleDto[], ErrorResponse>({
        path: `/system`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetOperationsByModuleAndService
     * @summary Получение списка всех операций связанных с сервисом модуля
     * @request GET:/system/operations/byModuleAndService
     * @secure
     */
    getOperationsByModuleAndService: (
      query: {
        moduleName: string;
        serviceName: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AppModuleDto, ErrorResponse>({
        path: `/system/operations/byModuleAndService`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  audit = {
    /**
     * No description
     *
     * @name GetAuditData
     * @summary Получение данных аудита в интервале времени с пагинацией
     * @request GET:/audit
     * @secure
     */
    getAuditData: (params: RequestParams = {}) =>
      this.request<AppAuditDto[], ErrorResponse>({
        path: `/audit`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Создать запись аудита
     *
     * @name CreateAuditData
     * @request POST:/audit
     * @secure
     */
    createAuditData: (data: AppAuditDto, params: RequestParams = {}) =>
      this.request<AppAuditDto, ErrorResponse>({
        path: `/audit`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
}
